var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thermostat"},[_c('x-switch',{attrs:{"value":_vm.boost()},on:{"change":function($event){return _vm.setBoost()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }